"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Game_1 = require("./Game");
const IGO50Scenes_1 = require("./IGO50Scenes");
class IGO50PausableScene extends Phaser.Scene {
    update(now, delta) {
        if (Game_1.gameManager.getController().getInput(Game_1.Controls.Start).isJustDown()) {
            this.pauseGame();
        }
    }
    pauseGame() {
        const key = this.scene.key;
        this.scene.pause(key);
        this.scene.run(IGO50Scenes_1.default.Pause, { pausedSceneKey: key });
    }
}
exports.default = IGO50PausableScene;
